import React  from 'react';
import { PropTypes } from 'prop-types';
import { navigate } from 'gatsby';

import {
  AddressContainer,
  Container,
  Name,
  Address,
  Tel,
  Map,
  Website
} from './styles'

const AddressTile = ({ name, street, city, country, phone, mapsLink, website, isWhite, viewMapText }) => (
  <AddressContainer isWhite = { isWhite }>
    <Container>
      { name && <Name>{ name }</Name> }
    </Container>
    <Container>
      { street && <Address>{ street }</Address> }
      { city && <Address>{ city }</Address> }
      { country && <Address>{ country }</Address> }
      { phone && <Tel href = { `tel:${phone}` }>{ phone }</Tel> }
    </Container>
    <Container>
      { mapsLink && <p><Map href = { mapsLink } target = 'blank'>{ viewMapText.toUpperCase() }</Map></p> }
      { website && <p><Website href = { website } target = 'blank'>{ website }</Website></p> }
    </Container>
  </AddressContainer>
);

AddressTile.propTypes = {
  city: PropTypes.string,
  country: PropTypes.string,
  isWhite: PropTypes.bool,
  mapsLink: PropTypes.string,
  name: PropTypes.string,
  street: PropTypes.string,
  tel: PropTypes.string,
  website: PropTypes.string,
  viewMapText: PropTypes.string,
};

export default AddressTile;
